
(function () {
  const cta     = document.getElementById('engraving-cta');
  const modal   = document.getElementById('engraving-modal');
  const closeBk = modal?.querySelector('.engraving-backdrop');
  const closeAr = document.getElementById('engraving-close');
  const closeX  = document.getElementById('engraving-x-button');

  if (!cta || !modal) return; // safety net — if either is missing, bail out

  function openModal()  { modal.setAttribute('aria-hidden', 'false'); }
  function closeModal() { modal.setAttribute('aria-hidden', 'true');  }

  cta.addEventListener('click', openModal);

  closeBk?.addEventListener('click', closeModal);
  closeAr?.addEventListener('click', closeModal);
  closeX?.addEventListener('click',  closeModal);
})();